module.exports = __webpack_public_path__ + "static/media/return-box.309f00f6.svg";